import { UseQueryResult } from "react-query";
import { useMemo } from "react";
import EndUseStackedBarChart from "../EndUseStackedBarChart";

interface AnnualCarbonEmissionsElectricityChartProps {
    query: () => UseQueryResult<AnnualCarbonEmissionsElectricityChartData>;
}

function AnnualCarbonEmissionsElectricityChart({ query }: AnnualCarbonEmissionsElectricityChartProps) {
    const { data, isLoading, error } = query();

    // [DP 2025-12-10]: We currently do not have an effective way of visually representing
    // negaive carbon emission on this chart. Check slack to reference the reason behind this
    // temporary fix.
    // https://audetteio.slack.com/archives/C05UQEXHM6C/p1765590565774649?thread_ts=1765573955.807979&cid=C05UQEXHM6C
    const dataWithoutRenewables = useMemo(() => {
        if (!data) return [];
        // @ts-ignore
        return data.map(({ renewable, ...rest }) => rest);
    }, [data]);

    return (
        <EndUseStackedBarChart
            data={dataWithoutRenewables}
            fuelTypeKey="electricity"
            loading={isLoading}
            error={error?.toString()}
        />
    );
}

export default AnnualCarbonEmissionsElectricityChart;
